import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ArticleServices = {
    getByCategory: async (search = "", category = "", isPaginated = true, pageSize = 10, pageNumber = 1,) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Article/GetByCategory`, {
                params: { search, category, isPaginated, pageSize, pageNumber },
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Không thể tải bài viết!";
            throw new Error(errorMessage);
        }
    },
    getArticleDetail: async (id, pageSize = 3, pageNumber = 1) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Article/GetArticleDetail`, {
                params: { id, pageSize, pageNumber },
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Không thể tải bài viết!";
            throw new Error(errorMessage);
        }
    },
    getById: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/Article/GetById/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Không thể tải dữ liệu bài viết!";
            throw new Error(errorMessage);
        }
    }
};

export default ArticleServices;